export { default } from '@shikijs/langs/sql'
